import { Button } from "@material-ui/core";
import { COLORS } from "constants/colors";
import useText from "constants/text";
import React from "react";

export interface VectorButtonProps {
  icon?: any;
  handleClick?: () => void;
  name?: string;
  color?: string;
  backgroundColor?: string;
  width?: string;
  height?: string;
  borderRight?: string;
  className?: string;
}
const VectorButton: React.FC<VectorButtonProps> = ({
  icon,
  handleClick,
  name,
  width,
  height,
  backgroundColor,
  color,
  borderRight,
  className,
}): React.ReactElement => {
  const { text } = useText();

  return (
    <>
      <Button
        startIcon={icon}
        style={{
          backgroundColor: COLORS.primary || backgroundColor,
          color: COLORS.white || color,
          borderRight,
          width,
          height,
        }}
        onClick={handleClick}
      >
        {name || `${text.all.export_task}`}
      </Button>
    </>
  );
};

export default VectorButton;
